const environment = (() => {
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT

  if (environment === 'local') {
    return 'test'
  }

  return environment
})()

export const MESSAGE_LIST_PATH = 'messagelist'
export const USER_PATH = 'users'
export const CHAT_ROOM_PATH = 'chatlist'

export const getChatRoomsPath = (userId: number) => {
  return `${environment}/${CHAT_ROOM_PATH}/${userId}`
}

export const getChatRoomPath = (userId: number, chatRoomId: number) => {
  return `${getChatRoomsPath(userId)}/${chatRoomId}`
}

export const getMessageListPath = (chatRoomId: number) => {
  return `${environment}/${MESSAGE_LIST_PATH}/${chatRoomId}`
}

export const getUserPath = (userId: number) => {
  return `${environment}/${USER_PATH}/${userId}`
}
